import { z } from 'zod';
import { DbJsonSchema } from '../../../dbJsonSchemas.js';
import { customFieldUiCollection } from '../../schema/customField.js';
export const stripeConfig = z.object({
    isExtendedAuthAllowed: z.boolean(),
    idFromPlatform: z.string(), // account_id
    id: z.number(),
});
export const settings = z.object({
    storeId: z.number(),
    storeSlug: z.string(),
    storeUrl: z.string().optional(),
    storeName: z.string().optional(),
    storefrontId: z.string(),
    isActive: z.boolean(),
    exchangeOrderPrefix: z.string().optional(),
    isClaimImageFromCustomerRequired: z.boolean(),
    /** parsed, so the UI always receives every flag with its default */
    featureFlags: DbJsonSchema.Store.featureFlags,
    stripeConfig: stripeConfig.optional(),
    localizeKey: z.string().optional(),
    registrations: z.object({
        isEnabled: z.boolean(),
        isAutomatedRegistrationEnabled: z.boolean(),
        shouldCollectProofOfPurchase: z.boolean(),
        shouldCollectAddress: z.boolean(),
        emailMarketingConsentPolicyUrl: z.string().optional(),
        shouldCollectRegistrationEmailMarketingConsent: z.boolean(),
        isStartWarrantyClaimEnabled: z.boolean(),
        customFields: customFieldUiCollection,
        storeSalesChannels: z.array(z.object({
            id: z.number(),
            name: z.string(),
        })),
    }),
    orderEditing: z.object({
        isEnabled: z.boolean(),
        /** When true, customer refunds from order edits are issued as store credit instead of returning to original payment. */
        useStoreCreditRefund: z.boolean(),
    }),
    tracking: z.object({
        isEnabled: z.boolean(),
    }),
    warranty: z.object({
        isEnabled: z.boolean(),
    }),
    return: z.object({
        isEnabled: z.boolean(),
        isGiftReturnEnabled: z.boolean(),
        isGiftCardEnabled: z.boolean(),
        isExchangeEnabled: z.boolean(),
        isRefundEnabled: z.boolean(),
        isClaimLineageEnabled: z.boolean(),
    }),
    theme: DbJsonSchema.StoreUiConfig.customerUiConfigSchema,
});
//# sourceMappingURL=settings.js.map